import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'concat',
    pure: false
})
export class TableTextConcat implements PipeTransform{
    transform(item: any, term: any): any {
        
        return term+item;
    }
}